{
  "vendors": {
    "pageError": {
      "title": "Something went wrong while loading the page.",
      "tryAgain": "Try Again",
      "goHome": "Go to Home",
      "please": "Please"
    },
    "dashboard": {
      "statsTitle": "Vendors",
      "activitiesTitle": "Last Updates",
      "draftsTitle": "Vendor Drafts"
    },
    "table": {
      "title": "Vendor Management",
      "search": "Search",
      "addButton": "Add New Vendor",
      "columns": {
        "name": "Name",
        "vendorId": "Vendor ID",
        "vendorCode": "Vendor Code",
        "contactEmail": "Contact email",
        "isActive": "Is Active",
        "lastModified": "Last Modified",
        "actions": "Actions"
      },
      "emptyState": {
        "title": "No vendors found.",
        "descriptionWithSearch": "Try adjusting your search criteria.",
        "descriptionNoData": "There are no vendors to display at this time."
      },
      "actions": {
        "view": "View vendor",
        "edit": "Edit vendor",
        "copy": "Copy"
      }
    }
  }
}
